const GLOBAL_NAME_LOADER = '%%LOADER_GLOBAL#+';

const resolveName = (name) => {
  return name ? name : GLOBAL_NAME_LOADER;
};

const gloading = {
  namespaced: true,
  state: {
    loadingStack: []
  },
  getters: {
    isLoading: (state) => (names) => {
      if (!Array.isArray(names)) {
        names = [names];
      }
      return names.some((name) => {
        const nameStack = resolveName(name);
        return !!state.loadingStack.find((item) => item === nameStack);
      });
    }
  },
  actions: {
    show({ commit }, name) {
      commit('show', name);
    },
    hide({ commit }, name) {
      commit('hide', name);
    },
    stop({ commit }) {
      commit('stop');
    }
  },
  mutations: {
    show(state, name) {
      const nameStack = resolveName(name);
      state.loadingStack.push(nameStack);
    },
    hide(state, name) {
      const nameStack = resolveName(name);
      const itemIndex = state.loadingStack.findIndex(
        (item) => item === nameStack
      );

      if (itemIndex >= 0) {
        state.loadingStack.splice(itemIndex, 1);
      }
    },
    stop(state) {
      state.loadingStack = [];
    }
  }
};

export default gloading;
